import {
  QButton,
  QModal,
  QModalActions,
  QModalBody,
  QModalHeader,
  QText,
} from '@qualio/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface DocumentCollaborationSessionResetProps {
  isOpen: boolean;
  onClose: () => void;
  doResetSession: () => Promise<void>;
}

export const DocumentCollaborationSessionDeleteModal = ({
  isOpen,
  onClose,
  doResetSession,
}: DocumentCollaborationSessionResetProps) => {
  const { t } = useTranslation();
  const [isBusy, setIsBusy] = useState(false);

  const resetEditorSession = async () => {
    setIsBusy(true);
    try {
      await doResetSession();
      window.location.reload();
    } catch (e) {
      console.log(e);
      setIsBusy(false);
    }
  };

  return (
    <QModal onClose={onClose} isOpen={isOpen}>
      <QModalHeader>
        <QText>{t('messages.resetDocumentEditorSession')}</QText>
      </QModalHeader>
      <QModalBody>
        <QText>
          {t('modals.resettingEditorSession')}
          <br />
          <br /> {t('modals.shouldOnlyResetIfEditorCannotLoad')}
        </QText>
      </QModalBody>
      <QModalActions>
        <QButton variant="outline" onClick={onClose}>
          {t('buttons.cancel')}
        </QButton>
        <QButton isLoading={isBusy} onClick={resetEditorSession}>
          {t('modals.resetDocumentSession')}
        </QButton>
      </QModalActions>
    </QModal>
  );
};
